import { createBrowserRouter, Navigate } from "react-router-dom";

import { globalRoutes } from "./global/global.routes";
import { privateRoutes } from "./private/private.routes";

// common-components
import GlobalPage from "./global/global.page";
import PrivatePage from "./private/private.page";
import NotFoundPage from "./shared/pages/not-found/not-found.page";
import AuthenticationPage from "./authentication/authentication.page";

const rootRouter = createBrowserRouter([
  {
    path: "/",
    element: <PrivatePage />,
    errorElement: <NotFoundPage />,
    children: [
      // Redirect can directly go here. Adjust this based on what page you want displayed as default
      {
        index: true,
        element: <Navigate to="/reporting-and-analytics/report-list" replace/>,
      },
      ...privateRoutes,
    ],
  },
  {
    path: "/login",
    element: <AuthenticationPage />,
    errorElement: <NotFoundPage />,
    children: [],
  },
  {
    path: "/user",
    element: <PrivatePage />,
    errorElement: <NotFoundPage />,
    children: [...privateRoutes],
  },
  {
    path: "/user/reporting-and-analytics/report-list",
    element: <PrivatePage />,
    errorElement: <NotFoundPage />,
    children: [...privateRoutes],
  },
]);
export default rootRouter;
